<!-- <svelte:options customElement="clever-search-rating" /> -->

<script lang="ts">
  import { state_answerRating, state_busyApi } from '../store/state';
  import { ConfigStore } from './../store/config';

  import { onDestroy } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { ApiTypes } from '../enums/api.enum';
  import { RatingTypes } from '../enums/question-rating.enum';
  import { WindowsCustomEventTypes } from '../enums/windows-custom-event.enum';
  import type { IUpdateRating } from './../interfaces/request-update-rating-question.interface';
  import RatingCurveTheme from './themes/rating-theme/rating-curve-theme.svelte';
  import RatingSmoothTheme from './themes/rating-theme/rating-smooth-theme.svelte';
  import { IconThemeType } from '../enums/themes/icon-theme-type.enum';

  let updateTimer: any;
  let updateSuccess: boolean;
  let updateFail: boolean;

  export let questionId: string;

  /** property to store timeout period for showing status*/
  let clearTime = 2147483647;

  $: isUpdating = $state_busyApi.includes(ApiTypes.putRating);

  // onMount(() => {
  //     shadowDomUpdates("clever-search-rating", true);
  // });

  onDestroy(() => {
    window.removeEventListener(
      WindowsCustomEventTypes.UpdateRatingStatus as string,
      showUpdateStatus as EventListener
    );
  });

  const sendRating = (val: any) => {
    if ($state_answerRating == val) return;

    updateSuccess = false;
    updateFail = false;
    clearTimeout(updateTimer);

    const data: IUpdateRating = {
      score: val,
      type: RatingTypes.thumbs,
      questionId,
    };

    window.dispatchEvent(
      new CustomEvent(WindowsCustomEventTypes.updateRating, {
        detail: data,
      })
    );
  };

  const showUpdateStatus = (e: CustomEvent<{ detail: any }>) => {
    try {
      const status = e.detail;

      updateSuccess = false;
      updateFail = false;
      clearTimeout(updateTimer);

      if (status) {
        updateSuccess = true;
      } else {
        updateFail = true;
      }

      updateTimer = setTimeout(() => {
        updateSuccess = false;
        updateFail = false;
      }, clearTime);
    } catch (e) {
      console.error(e);
    }
  };

  /** listen to window even for rating api update status*/
  window.addEventListener(
    WindowsCustomEventTypes.UpdateRatingStatus as string,
    (e) => showUpdateStatus(e as CustomEvent<{ detail: any }>)
  );
</script>

{#if $ConfigStore.ratingType === RatingTypes.nps}
  todo
{:else}
  <!-- default loading is thumbs view-->
  <div
    role="group"
    aria-labelledby="cs-rating-legend"
    class={'cs-rating-wrapper cs-type-' + $ConfigStore.widgetType}
  >
    <div class="cs-rating-wrapper-panel">
      <p
        title={$_('rating.thank_feedback')}
        class="cs-rating-success"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {#if updateSuccess}{$_('rating.thank_feedback')}{/if}
      </p>
      {#if updateFail}
        <p class="cs-rating-error">
          {$_('rating.unable_send_feedback')}
        </p>
      {/if}
      <fieldset class="cs-rating-group">
        <legend id="cs-rating-legend" class="cs-info">
          {$_('rating.how_did_i_do')}
        </legend>
        {#if $ConfigStore.customTheme.iconThemeType === IconThemeType.smoothicon}
          <RatingSmoothTheme
            {updateTimer}
            {updateSuccess}
            {updateFail}
            {isUpdating}
            {sendRating}
          />
        {:else if $ConfigStore.customTheme.iconThemeType === IconThemeType.curveicon}
          <RatingCurveTheme
            {updateTimer}
            {updateSuccess}
            {updateFail}
            {isUpdating}
            {sendRating}
          />
        {:else}
          <button
            class="cs-thumb up"
            class:busy={isUpdating}
            class:active={$state_answerRating?.score == 1}
            aria-label={$_('rating.thumbs_up')}
            title={$_('rating.thumbs_up')}
            on:keypress={() => sendRating(1)}
            on:click={() => sendRating(1)}
          ></button>
          <button
            class="cs-thumb down"
            class:busy={isUpdating}
            class:active={$state_answerRating?.score == 0}
            aria-label={$_('rating.thumbs_down')}
            title={$_('rating.thumbs_down')}
            on:keypress={() => sendRating(0)}
            on:click={() => sendRating(0)}
          ></button>
        {/if}
      </fieldset>
    </div>
  </div>
{/if}
{#if $ConfigStore.customCSSUrl}
  {#if $ConfigStore.customCSSIntegrity}
    <link
      href={$ConfigStore.customCSSUrl}
      rel="stylesheet"
      type="text/css"
      integrity={$ConfigStore.customCSSIntegrity}
      crossorigin="anonymous"
    />
  {:else}
    <link href={$ConfigStore.customCSSUrl} rel="stylesheet" type="text/css" />
  {/if}
{/if}

<style lang="scss">
  @use './../../scss/components/_rating';
</style>
